import { m as a } from "./math-sign.js";
var r = Math.abs,
  t = Math.pow,
  o = t(2, -52),
  m = t(2, -23),
  n = t(2, 127) * (2 - m),
  h = t(2, -126),
  s = Math.fround || function (t) {
    var s,
      u,
      f = +t,
      i = r(f),
      p = a(f);
    return i < h ? p * (i / h / m + 1 / o - 1 / o) * h * m : (u = (s = (1 + m / o) * i) - (s - i)) > n || u != u ? p * (1 / 0) : p * u;
  };
export { s as m };